import { M } from "./Hero";

export const Programa = () => (
  <section className="light" id="programa" data-testid="programa-section">
    <div className="wrap">
      <div className="split reveal">
        <div>
          <h2>Educación emocional para rendir y ser feliz</h2>
          <p className="lead" style={{ marginTop: 18 }}>Por medio de la psicología impactamos de forma positiva el rendimiento y la percepción de felicidad de deportistas, artistas, músicos, estudiantes y empresarios, y ayudamos a cada joven a construir su proyecto de vida.</p>
          <ul className="checks">
            <li>Colegios y academias deportivas</li>
            <li>Grupos musicales, artistas y casas culturales</li>
            <li>Empresas que quieren equipos de alto desempeño</li>
          </ul>
          <a className="btn btn-navy" href="#contacto" data-testid="programa-llevar-btn">Llevar el programa a mi institución</a>
        </div>
        <div className="media"><img src={M("real/respiracion.webp")} alt="Sesión de relajación y respiración con jóvenes deportistas" loading="lazy" /></div>
      </div>
      <div className="trio">
        <article className="tile t1 reveal" data-testid="tile-becas"><div><h3>Becas deportivas</h3><p>Recursos y becas para que los atletas sigan su formación académica y profesional a través del deporte.</p></div><a className="btn btn-sol" href="#donar" data-testid="tile-becas-btn">Becar a un atleta</a></article>
        <article className="tile t2 reveal" data-testid="tile-sporting"><div><h3>Sportingtimebq</h3><p>Marca creada por la fundación: el 100&nbsp;% de la utilidad apoya a nuestros deportistas.</p></div><a className="btn btn-navy" href="https://www.instagram.com/fundacion1111/" target="_blank" rel="noopener noreferrer" data-testid="tile-sporting-btn">Ver en Instagram</a></article>
        <article className="tile t3 reveal" data-testid="tile-alianzas"><div><h3>Alianzas y patrocinios</h3><p>Empresas del sector apoyando implementos, transporte, alimentación y torneos.</p></div><a className="btn btn-sol" href="#contacto" data-testid="tile-alianzas-btn">Ser aliado</a></article>
      </div>
    </div>
  </section>
);

export const VideoApoyemos = () => (
  <section id="video" style={{ paddingTop: 0, background: "var(--paper)" }} data-testid="video-section">
    <div className="wrap">
      <div className="split rev reveal" style={{ background: "var(--navy)", borderRadius: 28, padding: "clamp(20px,4vw,40px)", color: "#fff" }}>
        <div className="media" style={{ background: "#000" }}>
          <video autoPlay muted loop playsInline preload="metadata" poster={M("real/apoyemos.webp")} data-testid="apoyemos-video">
            <source src={M("apoyemos.mp4")} type="video/mp4" />
          </video>
        </div>
        <div>
          <h2 style={{ fontSize: "clamp(1.8rem,4.5vw,2.8rem)" }}>#ApoyemosElDeporte</h2>
          <p className="lead" style={{ marginTop: 16 }}>En los barrios del sur de Barranquilla hay niños y jóvenes con un potencial enorme. Les falta acompañamiento emocional, académico y recursos. Ahí estamos.</p>
          <a className="btn btn-sol" href="#donar" data-testid="video-ayudar-btn">Quiero ayudar</a>
        </div>
      </div>
    </div>
  </section>
);
